import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import constants from "../../utils/constants";

const FAQ = () => {
  const theme = useTheme();
  const { faq } = constants;

  return (
    <Box sx={{ width: "100%", mt: 4, overflow: "hidden", px: 3 }}>
      {/* Title */}
      <Typography variant="h5" sx={{ fontWeight: "bold", color: theme.palette.primary.main, mb: 1 }}>
        {faq.title}
      </Typography>

      {/* Intro Note */}
      <Typography variant="body1" sx={{ color: theme.palette.heading_color.main, mb: 2, fontStyle: "italic", fontWeight: "bold" }}>
        {faq.note}
      </Typography>

      <Box sx={{ mb: 2 }}>
  <Typography variant="h5" sx={{ fontWeight: "bold", color: theme.palette.heading_color.main }}>
    {faq.heading1}
  </Typography>
  {[
    { title: faq.subheading1, content: faq.subheading1_note },
    { title: faq.subheading2, content: faq.subheading2_note },
    { title: faq.subheading3, content: faq.subheading3_note },
  ].map((section, index) => (
    <Box key={index}>
      <Typography variant="h6" sx={{ fontWeight: "bold", color: theme.palette.heading_color.main, mt: 2 }}>
        {section.title}
      </Typography>
      <Box>
        {index === 0 && section.content.includes("\n\n") ? (
          section.content.split("\n\n").map((paragraph, idx) => (
            <Box key={idx} sx={{  }}>
              <Typography variant="body1">
                {idx === 0 ? "" : `${idx}. `} 
                {paragraph.split("\n").map((line, lineIdx) => (
                  <React.Fragment key={lineIdx}>
                    {line}
                    {lineIdx < paragraph.split("\n").length - 1 && <br />}
                  </React.Fragment>
                ))}
              </Typography>
            </Box>
          ))
        ) : (
          section.content.split("\n").map((line, idx) => (
            <React.Fragment key={idx}>
              {line}
              {idx < section.content.split("\n").length - 1 && <br />}
            </React.Fragment>
          ))
        )}
      </Box>
    </Box>
  ))}
</Box>


      <Box sx={{ mb: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: "bold", color: theme.palette.heading_color.main }}>
          {faq.heading2}
        </Typography>
        {[
            { title: faq.subheading4, content: faq.subheading4_note },
            { title: faq.subheading5, content: faq.subheading5_note },
            { title: faq.subheading6, content: faq.subheading6_note },            
            { title: faq.subheading7, content: faq.subheading7_note },
            { title: faq.subheading8, content: faq.subheading8_note },
            { title: faq.subheading9, content: faq.subheading9_note },
            { title: faq.subheading10, content: faq.subheading10_note },
            { title: faq.subheading11, content: faq.subheading11_note },
       ].map((section, index) => (
            <Box key={index}>
            <Typography variant="h6" sx={{ fontWeight: "bold", color: theme.palette.heading_color.main, mt: 2 }}>
                {section.title}
            </Typography>
            <Box sx={{  }}>
                {section.content.split("\n").map((line, index) => (
                <React.Fragment key={index}>
                {line}
                <br />
                </React.Fragment>
            ))}
            </Box>
            </Box>
        ))}
      </Box>


      <Box sx={{ mb: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: "bold", color: theme.palette.heading_color.main }}>
          {faq.heading3}
        </Typography>
        {[
            { title: faq.subheading12, content: faq.subheading12_note },
            { title: faq.subheading13, content: faq.subheading13_note },
            { title: faq.subheading14, content: faq.subheading14_note },            
            { title: faq.subheading15, content: faq.subheading15_note },
            { title: faq.subheading16, content: faq.subheading16_note },
            { title: faq.subheading17, content: faq.subheading17_note },

       ].map((section, index) => (
            <Box key={index}>
            <Typography variant="h6" sx={{ fontWeight: "bold", color: theme.palette.heading_color.main, mt: 2 }}>
                {section.title}
            </Typography>
            <Box sx={{  }}>
                {section.content.split("\n").map((line, index) => (
                <React.Fragment key={index}>
                {line}
                <br />
                </React.Fragment>
            ))}
            </Box>
            </Box>
        ))}
      </Box>

      <Box sx={{ mb: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: "bold", color: theme.palette.heading_color.main }}>
          {faq.heading4}
        </Typography>
        {[
            { title: faq.subheading18, content: faq.subheading18_note },
            { title: faq.subheading19, content: faq.subheading19_note },
            { title: faq.subheading20, content: faq.subheading20_note },            
            { title: faq.subheading21, content: faq.subheading21_note },

       ].map((section, index) => (
            <Box key={index}>
            <Typography variant="h6" sx={{ fontWeight: "bold", color: theme.palette.heading_color.main, mt: 2 }}>
                {section.title}
            </Typography>
            <Box sx={{  }}>
                {section.content.split("\n").map((line, index) => (
                <React.Fragment key={index}>
                {line}
                <br />
                </React.Fragment>
            ))}
            </Box>
            </Box>
        ))}
      </Box>


        <Box sx={{ mb: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: "bold", color: theme.palette.heading_color.main }}>
          {faq.heading5}
        </Typography>
        <Box sx={{ color:theme.palette.heading_color.main }}>
            {faq.heading5_note.split("\n").map((line, index) => (
                <React.Fragment key={index}>
                {line}
                <br />
                </React.Fragment>
            ))}
        </Box>
        </Box>

    </Box>
  );
};

export default FAQ;
